import { makeProgressData } from '@/middlewares/C3Wrapper/MakeProgressData/MakeProgressData'

class C3Wrapper {
  static makeProgressData({ data, targetBudget, today, bpStart, bpEnd }) {
    return makeProgressData({ data, targetBudget, today, bpStart, bpEnd })
  }
  static groupedBar({ json, chartItem, budgetItem, xAxisName, height = 300 }) {
    const options = {}

    options.size = { height }

    options.data = {}
    options.data.order = null
    options.data.type = 'bar'
    options.data.json = json

    options.data.keys = {}
    options.data.keys.x = xAxisName

    options.data.keys.value = [chartItem.name, budgetItem.name]

    options.data.names = {
      [chartItem.name]: chartItem.displayName,
      [budgetItem.name]: budgetItem.displayName,
    }

    options.data.groups = [[chartItem.name, budgetItem.name]]

    options.axis = {}
    options.axis.x = {}
    options.axis.x.tick = {
      format: '%Y-%m-%d',
    }

    options.axis.x.type = 'timeseries'

    options.tooltip = {}
    options.tooltip.grouped = false

    options.legend = {}
    options.legend.hide = [budgetItem.name]

    options.tooltip = {}
    options.tooltip.format = {}
    options.tooltip.format.value = (value, ratio, id) => {
      switch (id) {
        case budgetItem.name:
          return budgetItem.format(value)
        case chartItem.name:
          return chartItem.format(value)
        default:
          return value
      }
    }

    return options
  }
}

export default C3Wrapper
